Object.defineProperty(exports,"__esModule",{value:true});exports.default=void 0;var _default=true;exports.default=_default;
//# sourceMappingURL=index.web.js.map